enum ApiKeys {
  UserCurrent = 'api/user/current',
  UserCurrentShippingAddress = 'api/user/current/address/shipping',
  UserCurrentBalance = 'api/user/current/balance',
}

export { ApiKeys }
